"use strict";

(function (global) {
  // Доступные статусы.
  var availableStatuses = ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Completed', 'Clean'];
  // Регулярка для извлечения статуса по имени css-класса.
  var statusNameInClassRX = /um(.+)/i;

  /**
  * @inner
  * Получает имя картинки статуса по его названию.
  */
  var getStatusIconByStatusName = function (statusName, opt_normalClean) {
    if (statusName == 'Clean' && opt_normalClean !== true) return 'status-20';
    else return 'um' + statusName;
  };

  /**
  * Изменение иконки статуса в тулбаре.
  * @inner
  */
  var changeStatusToolbarButtonIconByEl = function (toolItemEl, statusName) {
    if (!!toolItemEl) {
      window.WA.current.toolBar.buttons[$(toolItemEl).attr('name')].setIcon(getStatusIconByStatusName(statusName));
    }
  };

  // Сохраняет новый статус в БД.
  var setUserStatus = function (statusName, toolItemEl, afterChangeCallback, isForList) {
    // скроем меню.
    ContextMenu.hide();

    if (isForList) {
      massSetUserStatus(statusName, window.WA.CR.objectList.getSelectedItems(), afterChangeCallback);
    } else {
      // Находимся в карточке.
      global.processCurrentObject(function (obj) {
        window.WA.services.entity.setUserStatus(obj, statusName).success(function () {
          if (afterChangeCallback) afterChangeCallback(obj, statusName);
        });
      });
    }
  };

  var massSetUserStatus = function (statusName, items, afterChangeCallback) {
    const mode = GetParamInURL("mode");

    // Обрабатываем все выделенные объекты только находясь в списке контента папки.
    if ((window.WA.current.objectList.isAllItemsSelected()) && (window.WA.current.getKind() === 'FOL') && (mode !== 'placedin') ) {
      // Проверим поиск это или нет. Если поиск, то нельзя устанавливать статусы всех объектов.      
      if (mode === '') {
        // Выделенны все объекты в папке.
        var folderId = WA.current.getID();
        // Отправим запрос на изменнение статуса на сервер.
        window.WA.services.folder.setStatusForAllObjects(folderId, statusName).success(function () {
          var items = window.WA.CR.objectList.getSelectedItems();
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // Пропускаем записи справочника.
            if (item.kind.toUpperCase() !== 'REF') {
              if (afterChangeCallback) afterChangeCallback({ id: item.id, kind: item.kind }, statusName);
            }
          }
        });
      } else {
        ShowError(L('ERR_CAN_NOT_CHANGE_OBJECTS_USER_STATUS_IN_SEARCH_RESULT'));
      }
    } else {
      // Выделенны НЕ все объекты, либо мы не в папке.
      for (var i = 0; i < items.length; i++) {
        var obj = { id: items[i].id, kind: items[i].kind };
        // Пропускаем записи справочника.
        if (obj.kind.toUpperCase() !== 'REF') {
          var succFunc = (function (obj) { // для предотвращения замыкания obj в цикле.
            return function () {
              if (afterChangeCallback) afterChangeCallback(obj, statusName);
            };
          })(obj);
          window.WA.services.entity.setUserStatus(obj, statusName).success(succFunc);
        };
      };
    };
  };

  /**
  * Обновляет стасус у элемента списка объектов.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.updateStatusInList
  */
  global.updateStatusInList = function (obj, statusName) {
    // сменим картинку статуса.
    var statusEl = $('#' + obj.id).find('.status:first');
    if (statusEl.length > 0) {
      statusEl.removeClass(function (index, classes) {
        var reg = new RegExp("um.+", "i");
        var matches = classes.match(reg);
        if (!!matches) {
          return (matches.join(' '));
        } else {
          return '';
        }
      }).addClass('um' + statusName);
    }
    return global;
  };

  // Отображает меню выбора статуса.
  var showStatusContextMenu = function (toolItem, afterChangeCallback, isForList) {
    var userStatusMenu = getUserStatusMenu();
    userStatusMenu.width = 150;
    userStatusMenu.shiftY = 37;
    $.each(userStatusMenu.items, function () {
      var statusName = this.id;
      this.name = 'SetStatus';
      this.onClick = function () { setUserStatus(statusName, toolItem, afterChangeCallback, isForList); };
    })
    userStatusMenu.items[userStatusMenu.items.length - 2].bottomSeparator = true;
    $.extend(userStatusMenu, selectToolbarBtnOnShowContextMenu(toolItem));
    userStatusMenu.show(toolItem);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Отображает меню для изменения стасуса для текущего объекта.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.openStatusContextMenu
  */
  global.openStatusContextMenu = function (toolItem, afterChangeCallback) {
    showStatusContextMenu(toolItem, afterChangeCallback, false);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Отображает меню для изменения стасуса для первого выделенного объекта.
  * @since 5.0.0.4216
  * @function Core.toolBars.main.openStatusContextMenu
  */
  global.openStatusContextMenuForList = function (toolItem, afterChangeCallback) {
    showStatusContextMenu(toolItem, afterChangeCallback, true);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Получает статус у элемента.
  var getStatusOfItem = function (itemEl) {
    var statusEl = itemEl.find('.status:first');
    if (statusEl.length > 0) {
      // Выделяем имя статуса из названия класса. um<Название>
      var matches = statusNameInClassRX.exec(statusEl.attr('class'));
      if (!!matches && matches.length > 0) {
        return matches[1];
      }
    }
    return null;
  };

  /**
  * Инициализация кнопки смены статуса.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.statusButtonForListOnInit
  */
  global.statusButtonForListOnInit = function (toolItem) {
    $.when(window.WA.ObjectListInit).done(function () {
      window.WA.current.objectList.bind('onSelect', function (last, allItems) {
        if (allItems.length > 0) {
          toolItem.enable();

          // Находимся в списке.
          if (window.WA.current.objectList._isAllSelected) {
            // Выделенны все объекты в папке.
            toolItem.setIcon(getStatusIconByStatusName('Clean'));
            // В результатах поиска делаем кнопку не активной.
            const mode = GetParamInURL("mode");
            if (mode !== '' && mode !== 'placedin') {
              toolItem.disable();
            }
          } else {
            // Получаем все выбранные элементы списка.
            var statusName = null;
            var items = window.WA.CR.objectList.getSelectedItems();

            // Если выбраны только записи справочника, то кнопку дизэйблим.
            var isSelectedOnlyReferences = true;
            for (var i = 0; i < items.length; i++) {
              if (items[0].kind.toUpperCase() !== 'REF') {
                isSelectedOnlyReferences = false;
                break;
              }
            }
            if (isSelectedOnlyReferences) {
              toolItem.disable();
              toolItem.setIcon(getStatusIconByStatusName('Clean'));
              return global;
            }
          }
        } else {
          toolItem.disable();
          toolItem.setIcon(getStatusIconByStatusName('Clean'));
        }
      });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Определяем общий статус, что бы правильно изменить иконку в риббоне.
  var getStatusNameForItems = function (items) {
    var statusName = null;
    for (var i = 0; i < items.length; i++) {
      var elStatusName = getStatusOfItem($('#' + items[i].id));
      if (!!elStatusName) {
        if (statusName === null) statusName = elStatusName;
        if (statusName !== elStatusName) {
          statusName = 'Clean';
          break;
        }
      }
    }
    if (statusName === null) statusName = 'Clean';
    return statusName;
  };


  /**
  * Отображаем меню статусов в виде горизонтальной полоски.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.showHorizontalStatusContextMenu
  */
  global.showHorizontalStatusContextMenu = function (generalMenu, menuIconEl, objs, isRightButton) {
    var items;
    if ($.isArray(objs)) {
      items = objs;
    } else {
      items = [objs];
    }

    var itemsStatus = getStatusNameForItems(items);

    // Формируем элементы меню.
    var menuitems = [];
    for (var i = 0; i < availableStatuses.length; i++) {
      var text = L('CHANGE_STATUS') + ': ' + (L("USER_STATUS_" + availableStatuses[i].toUpperCase()).toLowerCase());
      menuitems.push({
        name: availableStatuses[i],
        text: text,
        image: getStatusIconByStatusName(availableStatuses[i], true),
        imageCSSClass: availableStatuses[i],
        selected: (availableStatuses[i] === itemsStatus)
      });
    }


    // Генерируем меню.
    var menuId = 'statusesCM';
    var menu = new window.WebAccess.components.menus.OnlyIconsContextMenu(menuIconEl, menuitems, {}, menuId, isRightButton);

    menu.render();
    menu.bind('itemSelect', function (item) {

      if (Core.isStatisticEnabled) {
        ///Запись в статистику
        WA.CR.statistics.write({
          page: WA.getLocation(),
          action: (items.length > 1 ? 'Mass' : '') + 'SetStatus',
          area: 'OnlyIconsContextMenu',
          target: (items.length > 1 ? 'Mass' : (isRightButton ? items[0].tr.get(0) : menuIconEl.get(0)))
        });
      };

      var statusName = item.name;
      massSetUserStatus(statusName, items, function (obj, statusName) {
        global.updateStatusInList(obj, statusName);
      });
      ContextMenu.hide();
    });

    // Отображаем внутри обычного контекстного меню.

    var oldOnShow = generalMenu.onShow;

    generalMenu.shiftY = -25;
    generalMenu.onShow = function () {
      if ($.isFunction(oldOnShow)) oldOnShow();
      menu.jMenu.css({ 'margin-bottom': '10px' });
      menu.showIn($('#mainContextMenuContainer'), true);
    };


    return menu;
  };


})(window.Core.toolBars.main);